import { Occupancy } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import { match } from "ts-pattern"
import { plural, t } from "@lingui/macro"
import { ECommerceState } from "../../../app-core/v3/_common/machines/ecommerce-machine/e-commerce-machine"
import { maybeFareCardByKey } from "../../../app-core/v3/_common/read-models/fare"
import { stringIsPresent } from "../../../app-core/_common/checks"
import { StepRecapState } from "./StepRecap"

export const formatGuestsAndFare = (state: ECommerceState) => {
    const { guests, selectedFare: selectedFareRef } = state.context
    const selectedFare = maybeFareCardByKey(state.context, selectedFareRef?.key)
    return [formatGuests(guests), O.toUndefined(selectedFare)?.fareLabel].filter(Boolean).join(" | ")
}

const formatAdults = (adults: number) =>
    plural(adults, {
        one: "# Adult",
        other: "# Adults",
    })

const formatKids = (kids: number) =>
    plural(kids, {
        one: "# Child",
        other: "# Children",
    })

export const formatGuests = (guests: Occupancy) => {
    return [guests.adults > 0 && formatAdults(guests.adults), guests.kids > 0 && formatKids(guests.kids)]
        .filter(Boolean)
        .join(" | ")
}

export const stepStatus = (value: string | undefined, activeStep: boolean): StepRecapState => {
    const withValue = !!stringIsPresent(value)
    return match<[boolean, boolean], StepRecapState>([withValue, activeStep])
        .with([true, false], [true, true], () => "active")
        .with([false, true], () => "active-no-value")
        .with([false, false], () => "disabled")
        .exhaustive()
}
